import {adminHttpClient} from "../commons/adminHttpClient";


const deleteUser = (id : string) : Promise<any> => {
    return adminHttpClient.delete(`/DeleteUser/${id}`, {
        data:{id : id}
    })
}

export default deleteUser;